import { api } from "@/shared/api/api";

const feedbackApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sendFeedbackSubmissionSuccessEmail: builder.mutation<void, { username: string; feedback: string }>({
      query: ({ username, feedback }) => ({
        url: "/feedback",
        method: "POST",
        body: { username, feedback },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useSendFeedbackSubmissionSuccessEmailMutation } = feedbackApi;
